<template>
  <DisclosureButtonBase>
    <slot />
    <template #disclosure>
      <span v-if="value">
        {{ formatCents(value) }}
      </span>
      <span v-else-if="bundle.validSize">
        ${{ $cart.totalPrice / 100 }}
      </span>
      <span v-else>
        {{ bundle.totalQuantity }}/{{ bundle.size }}
      </span>
    </template>
  </DisclosureButtonBase>
</template>

<script setup lang="ts">
import { DisclosureButton as DisclosureButtonBase } from '@oatsovernight/storybook'

import { useBundleStore } from '@/stores'
const bundle = useBundleStore()
import { formatCents } from '@/utils'
export interface Props {
  value?: number
}
defineProps<Props>()
</script>

<style>
@reference 'tailwindcss';

.disclosure-button {
  &:disabled .disclosure,
  &.\+gray .disclosure {
    @apply !bg-neutral-500;
  }
  &.\+green .disclosure,
  &.\+border .disclosure {
    @apply bg-green-600;
  }
}
</style>
